import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { Button } from '@mui/material';
import { Settings as SettingsIcon } from '@mui/icons-material';

/**
 * Small outlined MUI `Button` with a Settings icon that pushes `to` onto the
 * router history when clicked; the label defaults to "View Details". Use in
 * table rows or cards to link through to a record's detail page.
 */
const DetailsButton = ({ className, disabled, name, to }) => {
  const history = useHistory();

  return (
    <Button
      className={className}
      disabled={disabled}
      onClick={() => history.push(to)}
      size="small"
      startIcon={<SettingsIcon />}
      variant="outlined"
    >
      {name}
    </Button>
  );
};

DetailsButton.defaultProps = {
  className: '',
  disabled: false,
  name: 'View Details',
};

DetailsButton.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  /** Visible button label. */
  name: PropTypes.string,
  to: PropTypes.string.isRequired,
};

export default DetailsButton;
